import React, { createContext, useContext, useState } from "react";

const PrezentacijaContext = createContext(null);

export function PrezentacijaProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return (
    <PrezentacijaContext.Provider value={{ openModal, closeModal, isOpen }}>
      {children}
    </PrezentacijaContext.Provider>
  );
}

export function usePrezentacija() {
  return useContext(PrezentacijaContext);
}
